<template>
  <div>
    <Navbar :appTitle="appTitle" />
    <div
      class="form-content wrap-apply"
      :style="{
        top: GLOBAL.currentEnvironment ? '0' : '',
        height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 100px)',
        paddingBottom: GLOBAL.currentEnvironment ? '120px' : '',
      }"
    >
      <div class="d-head">
        <div class="content">
          <div class="left">
            <div class="title" style="max-width: 6rem;">{{ buildForm.taskCode || '-' }}</div>
            <div class="row">
              <span style="color:#191f25">业务类型：{{buildForm.typeText || "-"}}</span>
            </div>
          </div>
          <div class="right">
            <div class="row warining">
              待收货：
              <span>{{buildForm.unReceivedNum}}</span>
            </div>
            <div class="row success" @click="toDetail">
              已收货：
              <span>{{buildForm.receivedNum}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="list" v-if="entryDetails.length != 0">
        <div class="operation">
          <div>
            <img
              @click="changeItem(true)"
              v-if="checkboxList.length == 0"
              class="img1"
              src="../../../assets/btna.png"
              alt=""
            />
            <img
              @click="changeItem(true)"
              v-if="
                checkboxList.length !== 0 &&
                checkboxList.length !== entryDetails.length
              "
              class="img2"
              src="../../../assets/btnb.png"
              alt=""
            />
            <!-- 勾选 -->
            <img
              @click="changeItem(false)"
              v-if="
                checkboxList.length !== 0 &&
                checkboxList.length === entryDetails.length
              "
              class="img2"
              src="../../../assets/btnc.png"
              alt=""
            />
            <span class="imgSpan">
              物品明细
            </span>
          </div>
        </div>
        <van-checkbox-group
          v-model="checkboxList"
          ref="checkboxGroup"
          direction="horizontal"
        >
          <van-checkbox
            v-for="(p, i) in entryDetails"
            :key="i"
            class="wrap"
            :name="i"
            shape="square"
            :label-disabled="true"
          >
            <div style="padding-top: 10px;">
              <van-cell-group>
                <div class="top">
                  <div class="title titleWidth">
                    {{ p.goodsCode || '-'}}| {{ p.goodsName || '-'}}| {{ p.goodsSpec || '-'}}
                  </div>
                </div>
                <div class="center">
                  <div>
                    <p>
                      <span class="key">产地：</span>
                      <span class="value">{{ p.address || '-'}}</span>
                    </p>
                    <p>
                      <span class="key">包装规格：</span>
                      <span class="value">{{ p.packageSpec	|| '-'}}</span>
                    </p>
                    <p>
                      <span class="key">单位：</span>
                      <span class="value">{{ p.unitName	|| '-'}}</span>
                    </p>

                    <p>
                      <span class="key">批号：</span>
                      <span class="value">{{ p.batchCode	|| '-'}}</span>
                    </p>
                    <p>
                      <span class="key">生产日期：</span>
                      <span class="value">{{ p.produceDate	|| '-'}}</span>
                    </p>
                    <p>
                      <span class="key">待收货/总应收：</span>
                      <span class="value">{{ p.unReceivedNumText	|| '-'}} / {{ p.inboundGoodsNumText	|| '-'}}</span>
                    </p>
                  </div>
                </div>
                <div class="bottomLine"></div>
                <van-cell-group class="formItemFlex">
                  <p class="label required FormTit"><span></span>收货库位</p>
                  <div class="haveUnitBox">
                    <van-field
                      v-model="p.latticeFullName"
                      placeholder="请选择或扫码"
                      input-align="right"
                      readOnly
                      @click="showLatticeNotification(i)"
                    >
                    <template #right-icon>
                      <div style="display: flex;">
                        <van-icon
                          @click.stop="showLatticeNotification(i)"
                          size="20"
                          color="#999"
                          name="arrow"
                          style="margin-top: 2px"
                        />
                        <van-icon
                          @click.stop="clickCode(i)"
                          size="20"
                          color="#999"
                          name="scan"
                          style="margin-top: 2px"
                        />
                      </div>
                    </template>
                    </van-field>
                  </div>
                </van-cell-group>
                <div class="bottomLine"></div>
                <van-cell-group class="formItemFlex">
                  <p class="label required FormTit"><span></span>收货数量</p>
                  <div class="haveUnitBox">
                    <van-field
                      v-model="p.receiptedNum"
                      type="number"
                      placeholder="请输入"
                      input-align="right"
                      :formatter="(e) => clearNoNum(e, p.unReceivedNum)"
                    />
                  </div>
                </van-cell-group>
              </van-cell-group>
            </div>
          </van-checkbox>
        </van-checkbox-group>
      </div>
      <van-empty v-else description="待收货数据为空" />
      <div class="search-bottoms">
        <van-button class="btnconfirm" :loading="subLoading" loading-text="提交中..." @click="btnConfirm">提交</van-button>
      </div>
    </div>
    <!--选择库位 -->
    <binLocation-pickers-ak
      v-if="isShowLatticeNotification"
      :columns="latticeNotificationgColumns"
      :listUrl="latticeNotificationUrl"
      @handleList="handleList"
    ></binLocation-pickers-ak>
    <!-- 浏览器扫码组件 -->
    <qrcode
      :qrcode="codeForm.qrcode"
      :showClose="codeForm.showClose"
      v-show="codeForm.qrcode"
      :camera="camera"
      :torchActive="torchActive"
      @switchCamera="switchCamera"
      @ClickFlash="ClickFlash"
      @turnCameraOff="turnCameraOff"
      @onDecode="onDecode"
      @onInit="onInit"
    />
     <!-- 激光扫码组件 -->
    <PDAsao @changeScan="changeScan2" />
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import scanInput from "@/components/scanCode/scanInput";
import BinLocationPickersAk from "@/components/choiceuse/BinLocationPickersAk";
import {
  receiptInfoListByGoods,
  receipted,
  getWarehouseLatticeDetail
} from "@/api/inventoryOrder";
import store from "@/store";
import PDAsao from "@/components/scanCode/PDAsao.vue";

export default {
  name: "warehousingTaskForm",
  components: {
    Navbar,
    VanFieldSelectPicker,
    BinLocationPickersAk,
    scanInput,
    qrcode: () => import("@/components/scanCode"),
    PDAsao
  },
  data() {
    return {
      appTitle: "收货",
      buildForm: {
        taskId: "",
        applyUserId: "",
      },
      recentGoodsIndex: 0,
      entryDetails: [],
      isShowLatticeNotification: false,
      latticeNotificationUrl: "/wmslattice/getLatticeNotification",
      latticeNotificationgColumns: {
        titleKey: ["latticeCode", "latticeName"], //标题
        content: [
          //内容
          {
            name: "库位物品",
            key: ["goodsNameTxt"],
          },
          {
            name: "物品数量",
            key: ["goodsNumTxt"],
          },
          {
            name: "物品总数量",
            key: ["totalNum"],
          },
        ],
        labelKey: [], //标签
        operationText: "",
      },
      checkboxList: [],
      // 扫码相关
      codeForm: {
        qrcode: false,
        showClose: true,
      },
      torchActive: true,
      camera: "off",
      subLoading: false
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.isShowLatticeNotification) {
      this.isShowLatticeNotification = false;
      this.appTitle = '收货';
      next(false);
    } else {
      next();
    }
  },
  async created() {
    store.commit("SET_CURRENT_PREFIX", "/jksaas-produce/produce");
    this.initData();
  },
  methods: {
    //已收货
    toDetail() {
      this.$router.push({
        path: "/receiptedGoodsDetail",
        query: {
          id: this.buildForm.taskId,
        },
      });
    },
    // 重置form表单
    resetForm () {
      this.buildForm = {
        taskId: "",
        applyUserId: "",
      }
      this.recentGoodsIndex = 0
      this.entryDetails = []
      this.checkboxList = []
    },
    // 提交
    btnConfirm() {
      if(this.checkboxList.length == 0) {
        this.$toast('请勾选物品');
        return
      }

      let subGoodsDtoList = []
      if(this.checkboxList.length != this.entryDetails.length) {
        this.entryDetails.map((ele, index) => {
          let recIndex = this.checkboxList.findIndex((i) => index == i)
          if(recIndex != -1) {
            subGoodsDtoList.push(ele)
          }
        })
      }else {
        subGoodsDtoList = this.entryDetails
      }

      let isValidated = true;
      try {
        // 入库物品明细 为空 选项名称、数量 表单验证
        if (subGoodsDtoList && subGoodsDtoList.length > 0) {
          subGoodsDtoList.forEach((element, index) => {
            if (!element.latticeId || element.latticeId == "") {
              isValidated = false;
              throw new Error(`物品（${element.goodsName}）收货库位不可为空`);
            }
            if (!element.receiptedNum || element.receiptedNum == "" || element.receiptedNum == 0) {
              isValidated = false;
              throw new Error(`物品（${element.goodsName}）收货数量不可为空且不为零`);
            }
          });
        } else {
          isValidated = false;
          throw new Error(`请选择物品`);
        }

        if (!isValidated) {
          return;
        }
      } catch (error) {
        this.$toast(error.message);
        return false;
      }
      this.handleSubmit(subGoodsDtoList);
    },
    handleSubmit(subGoodsDtoList) {
      let { taskId, applyUserId } = this.buildForm
      let params = {
        taskId: taskId,
        applyUserId: applyUserId,
        goodsDtoList: subGoodsDtoList.map((ele) => {
          return {
            goodsBatchId: ele.goodsBatchId, // 物品批次
            latticeId: ele.latticeId, // 库区
            taskDetailId: ele.taskDetailId, // 入库任务明细
            receiptedNum: ele.receiptedNum, // 收货人
          };
        }),
      };
      this.subLoading = true
      receipted(params).then((res) => {
        if (res.success) {
          this.$toast(res.message);
          this.initData();
        } else {
          this.$toast(res.message);
        }
        this.subLoading = false
      }).catch(() => {
        this.subLoading = false
      }).finally(() => {
        this.subLoading = false
      })
    },
    // 初始化页面数据
    initData() {
      let id = this.$route.query.id;
      let currentLoginUser = JSON.parse(localStorage.getItem("pro__Login_Userinfo")).value;

      this.resetForm()
      if(id) {
        // 收货详情
        receiptInfoListByGoods({taskId: id}).then((res) => {
          if (res.code == 200 && res.result) {
            this.buildForm = res.result;
            this.buildForm.applyUserId = currentLoginUser.id;
            this.entryDetails = res.result.unReceivedGoodsList.map((ele) => {
              return {
                ...ele,
                // latticeId: '',
                // latticeCode: '',
                // latticeName: '',
                // latticeFullName: '',
                receiptedNum: ele.unReceivedNum,
                taskDetailId: ele.id,
                latticeId: ele.defaultLatticeId,
                latticeCode: ele.defaultLatticeCode,
                latticeName: ele.defaultLatticeName,
                latticeFullName: (ele.defaultLatticeCode && ele.defaultLatticeName) ? ele.defaultLatticeCode + '|' + ele.defaultLatticeName : ''
              }
            })


            this.entryDetails.map((ele, index) => {
              if(ele.receiptedNum) {
                this.checkboxList.push(index)
              }
            })

          } else {
            this.$toast(res.message);
          }
        });
      }
    },
    // 控制全选、清空
    changeItem() {
      if (this.checkboxList.length) {
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        // 全部选中，并跳过禁用的复选框
        this.$refs.checkboxGroup.toggleAll({
          checked: true,
          skipDisabled: true,
        });
      }
    },
    // 库位选择
    showLatticeNotification(index) {
      this.recentGoodsIndex = index
      this.appTitle = '库位';
      this.isShowLatticeNotification = true
    },
    // 确认选中库位
    handleList(binLocationid, item, text) {
      let { id, latticeCode, latticeName } = item
      this.entryDetails = this.entryDetails.map((ele, index) => {
        let obj = ele
        if(index == this.recentGoodsIndex) {
          obj =  {
            ...ele,
            latticeId: id,
            latticeCode: latticeCode,
            latticeName: latticeName,
            latticeFullName: latticeCode + '|' + latticeName
          }
        }
        return obj
      })

      this.isShowLatticeNotification = false;
    },
    /*收货数量 处理*/
    clearNoNum(value, maxValue) {
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证.只出现一次，而不能出现两次以上
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      //只能输入四个小数
      value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3");
      // console.log(value.includes('.'),'wwwwww')
      //小数位处理
      if (value.substring(0, 1) == "0" && value.substring(0, 2) != "0.") {
        value = "0";
      }
      //输入长度控制
      if (value > 99999999999999.9999) {
        value = '';
      }
      //最大值限制
      if (Number(value) > maxValue) {
        value = ''
      }
      return value;
    },

    // 扫码相关
    // 打开相机
    clickCode(index) {
      let that = this;
      this.recentGoodsIndex = index
      let platform = localStorage.getItem("currentEnvironment");
      switch (platform) {
        case "iwork":
          var opt = {
            success: function(res) {
              console.log(JSON.stringify(res), "APP扫码数据");
              if (res.retCode == 0) {
                that.onDecode(res.retData);
              } else {
                that.$toast(res.retMsg);
              }
            },
            fail: function(err) {
              that.$toast("扫码失败！");
            },
          };
          //插件调用代码
          WorkHelper.scan(opt);
          break;
        case "browser":
          // camera:: 'front'--前摄像头，'rear'后摄像头，'off'关闭摄像头，会获取最后一帧显示，'auto'开始获取摄像头
          that.codeForm.qrcode = true;
          that.camera = "rear";
          break;
        case "dingding":
          dd.biz.util.scan({
            type: "qrCode", // type 为 all、qrCode、barCode，默认是all。
            onSuccess: function(data) {
              //onSuccess将在扫码成功之后回调
              that.onDecode(data.text);
            },
            onFail: function(err) {
              // console.error(err,'error')
            },
          });
          break;
        default:
          "";
          break;
      }
    },
    // 扫码结果回调
    onDecode(result) {
      // result, 扫描结果，可以根据自己的需求来实现相应的功能
      this.codeForm.code = JSON.parse(result);
      if (this.codeForm.code.EntityType == "lattice" && this.codeForm.code.id) {
        // 库位二维码
        getWarehouseLatticeDetail(this.codeForm.code.id).then((res) => {
          if(res.code == 200 && res.result) {
            if(res.result.status == 'effective') {
              this.handleList('',res.result, '')
              this.turnCameraOff()
            }else {
              this.$toast("该库位处于禁用状态");
              this.clickCode(this.recentGoodsIndex);
            }
          }
        })
      } else {
        this.$toast("请扫正确二维码");
        this.clickCode(this.recentGoodsIndex);
      }
    },
    // 相机反转
    switchCamera() {
      switch (this.camera) {
        case "front":
          this.camera = "rear";
          break;
        case "rear":
          this.camera = "front";
          break;
        default:
          this.$toast("错误");
      }
    },
    // 关闭相机
    turnCameraOff() {
      this.camera = "off";
      this.codeForm.qrcode = false;
    },
    // 打开手电筒
    ClickFlash() {
      switch (this.torchActive) {
        case true:
          this.torchActive = false;
          break;
        case false:
          this.torchActive = true;
          break;
        default:
          this.$toast("错误");
      }
    },
    // 检查是否调用摄像头
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "StreamApiNotSupportedError") {
        } else if (error.name === "NotAllowedError") {
          this.errorMessage = "Hey! I need access to your camera";
        } else if (error.name === "NotFoundError") {
          this.errorMessage = "Do you even have a camera on your device?";
        } else if (error.name === "NotSupportedError") {
          this.errorMessage =
            "Seems like this page is served in non-secure context (HTTPS, localhost or file://)";
        } else if (error.name === "NotReadableError") {
          this.errorMessage =
            "Couldn't access your camera. Is it already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.errorMessage =
            "Constraints don't match any installed camera. Did you asked for the front camera although there is none?";
        } else {
          this.errorMessage = "UNKNOWN ERROR: " + error.message;
        }
      }
    },
    // 激光扫码
    changeScan2(v) {
      if (v.EntityType == "lattice") {
        getWarehouseLatticeDetail(v.id).then((res) => {
          if(res.code == 200 && res.result) {
            if(res.result.status == 'effective') {
              let { id, latticeCode, latticeName } = res.result
              this.entryDetails = this.entryDetails.map((ele) => {
                let obj =  {
                    ...ele,
                    latticeId: id,
                    latticeCode: latticeCode,
                    latticeName: latticeName,
                    latticeFullName: latticeCode + '|' + latticeName
                  }
                return obj
              })
            }else {
              this.$toast("该库位处于禁用状态");
            }
          }else {
            this.$toast("数据异常");
          }
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
@import "@/views/workManagement/materialRequisition/materialForm.scss";
.form-content {
  width: 100%;
  height: calc(100vh - 203px);
  background: #f5f5f5;
  overflow: scroll;
  padding: 20px 0;
  .formgroup {
    background: #ffffff;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
  .search-bottoms {
    width: 100%;
    height: 100px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0rem 11px;
    box-sizing: border-box;
    font-size: 32px;
    font-weight: 500;
    z-index: 9;
    .btnconfirm {
      flex: 1;
      background: #1890ff;
      box-sizing: border-box;
      height: 78px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      color: #ffffff;
    }
  }
}
.bottomLine {
  height: 1px;
  background-color: #f2f2f2;
  margin: 0 2px;
}
.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 32px;
  /deep/ .van-cell {
    padding-right: 0;
    width: 490px;
  }
  /deep/ .van-field__control {
    max-width: 700px;
  }
}
/deep/ .van-nav-bar {
  z-index: 99;
}
/deep/.van-sidebar-item--select::before {
  color: #1890ff;
  background-color: #1890ff;
}
/deep/.van-tree-select__item--active {
  color: #1890ff;
}
.required span::after {
  left: -20px;
  top: 3px;
}
.filedClear {
  width: 28px;
  height: 28px;
}
.formItemFlex {
  display: flex;
  flex-direction: row;
  position: relative;
  left: -35px;
  .FormTit {
    min-width: 2.5rem;
    padding-top: 0.33rem;
  }
  .haveUnitBox {
    flex: 1;
  }
}
.list {
  margin-top: 10px;
  /deep/.van-checkbox__icon--square {
    top: -3.35rem;
    left: .1rem;
  }
  /deep/.van-checkbox--horizontal {
    margin-right: 0
  }
  /deep/.van-checkbox {
    margin-bottom: 10px
  }
  .operation {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: #ffff;
    display: flex;
    justify-content: space-between;
    padding: 0 11px;
    font-size: 28px;
    font-weight: 500;
    color: #191f25;
    border-bottom: 1px solid #f2f2f2;
    .img1 {
      width: 40px;
      height: 40px;
      margin-top: -10px;
    }
    .img2 {
      width: 40px;
      height: 40px;
      margin-top: -10px;
    }
    .imgSpan {
      margin-left: 2px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #191f25;
    }
  }
  .wrap {
    background: #fff;
    width: 100vw;
    .otherText {
      display: flex;
      justify-content: space-between;
      font-size: 32px;
      font-weight: bold;
      color: #191f25;
      .deleteStyle {
        font-weight: 400;
        color: #ff4d4f
      }
    }
    .top {
      display: flex;
      justify-content: flex-start;
      padding-top: 10px;
      .icon {
        width: 6px;
        height: 32px;
        background: #1890ff;
        margin: 6px 10px 0 10px;
      }
      .title {
        width: 602px;
        margin-right: 20px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #191f25;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .titleWidth {
        width: 572px;
      }
    }
    .center {
      p {
        margin: 16px 0;
        font-size: 28px;
        display: flex;
        position: relative;
        .key {
          color: #888888;
        }
        .value {
          color: #191f25;
          width: 380px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .arrow {
          color: #1890ff;
          position: absolute;
          right: -10px;
        }
      }
      .showAll {
        background: #f5f8ff;
        width: 100vw;
        margin-left: -30px;
        padding: 30px;
        margin-bottom: 30px;
      }
      .showAll2 {
        width: 100%;
        margin: 0 0 30px 0;
        padding: 30px 0;
      }
    }
  }
}
.d-head {
  width: 100%;
  padding: 32px;
  background: #ffffff;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      flex: 1;
      .title {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #191f25;
        line-height: 32px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .row {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #888888;
        margin-top: 20px;
      }
    }
    .right {
      flex: 1;
      text-align: right;
      font-size: 26px;
      .row {
        padding-top: 13px;
      }
      .warining {
        color: #fe9400;
      }
      .success {
        color: #4bd863;
      }
    }
  }
}
.otherTaps {
  background: #ffffff;
  padding: 32px;
  margin-top: 20px;
  .title {
    padding-bottom: 20px;
    border-bottom: 1px solid #eeeeee;
    .icon {
      display: inline-block;
      width: 6px;
      height: 28px;
      background: #1890ff;
    }
    .content {
      width: 126px;
      height: 32px;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #191f25;
      line-height: 44px;
      margin-left: 20px;
    }
  }
  .content {
    .row {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 32px;
      display: flex;
      .r-label {
        color: #888888;
        display: block;
        // width: 0.7rem;
        //   border: 1px solid red;
      }
      .r-column {
        display: block;
        color: #191f25;
        width: 500px;
        //   border: 1px solid red;
        //    width: 1rem;
      }
    }
    .fhrow {
      display: flex;
      .fhImg {
        width: 0.55rem;
        height: 0.55rem;
        border-radius: 0.1rem;
      }
      .rt-column {
        width: 2.55rem;
        //   height: 2.55rem;
        margin-left: 0.2rem;
        .rt-title {
          font-size: 0.16rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #191f25;
          margin-bottom: 0.16rem;
        }
        .rt-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.23rem;
          .column {
            //    border: 1px solid red;
            width: 1.5rem;
            .column-t {
              font-size: 0.14rem;
              font-family: PingFang SC;
              font-weight: 400;
              color: #888888;
              display: block;
              width: 100%;
              margin-bottom: 0.03rem;
            }
            .column-c {
              font-size: 0.16rem;
              font-family: PingFang SC;
              font-weight: 400;
              color: #191f25;
              display: block;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
.search-bottom {
  width: 100%;
  height: 100px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0 11px;
  box-sizing: border-box;
  font-size: 32px;
  font-weight: 500;
  z-index: 9;
  .searchContain {
    .btn {
      display: inline-block;
      box-sizing: border-box;
      width: 124px;
      height: 64px;
      align-items: center;
      border-radius: 6px;
      margin-right: 18px;
      text-align: center;
      line-height: 64px;
    }
    .confirm {
      background: #1890ff;
      color: #ffffff;
    }
    .cancel {
      border: 1px solid #b2b2b2;
      background: #f6f6f6;
      color: #5a5a5a;
    }
  }
}
</style>
